/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoMultiLocationPicker {
        restrict = 'E';
        searchCriteria: any = {};
        selectedState: any = undefined;
        selectedCity: any = undefined;
        selectedService: any = undefined;
        selectedLocationGroup: any = undefined;
        templateUrl = "app/components/controls/meevoMultiLocationPickerTemplate.html";
        constructor(private dataService: Meevo.Components.BaseClasses.IDataService, private identityService: Meevo.Components.Common.IIdentityService) {
        }

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: any, ngModel: angular.INgModelController, identityService: Meevo.Components.Common.IIdentityService) => {
            // Initialize model excludes
            scope.rightArray = scope.vm.context.selectedSection.model.locationOverride.locations ? scope.vm.context.selectedSection.model.locationOverride.locations : [];
            scope.searchCriteria = {};
            scope.cityCriteria = {};
            // Initialize item id
            scope.itemId = scope.vm.context.selectedSection.model.id;
            // Initialize business type selection
            scope.businessTypeDetail = scope.vm.context.selectedSection.model.businessTypeDetail;
            // Get business type id -> scope.vm.context.typeAheadBusinessTypeDetailId;
            scope.businessTypeId = Model.Guard.isSomething(scope.businessTypeDetail) ? scope.businessTypeDetail.id : this.identityService.current().tenantData.allBusinessTypeId;
            // Show business type if All BT selected in data maintenance form
            scope.displayBusinessType = scope.vm.context.selectedSection.model.businessTypeDetail.id === this.identityService.current().tenantData.allBusinessTypeId;

            scope.vm.selectedLocationIds = scope.rightArray.map((item) => { return item.locationId; });
            scope.noRecordsFound = false;

            scope.buildRequest = () => {
                scope.searchCriteria.city = scope.selectedCity ? scope.selectedCity.city : undefined;
                scope.searchCriteria.state = scope.selectedState ? scope.selectedState.state : undefined;
                scope.searchCriteria.locationGroupId = scope.selectedLocationGroup ? scope.selectedLocationGroup.id : undefined;
                scope.searchCriteria.filterBySessionUser = true;
                scope.searchCriteria.businessTypeId = scope.businessTypeId;
                scope.searchCriteria.locationStatus = [
                    Meevo.Model.LocationStatusEnum.Active,
                    Meevo.Model.LocationStatusEnum.ClosingPlanned,
                    Meevo.Model.LocationStatusEnum.TemporarilyClosed,
                    Meevo.Model.LocationStatusEnum.Closed
                ];
                scope.searchCriteria.subscriptionStatus = [Meevo.Model.SubscriptionStatusEnum.Active];
                scope.request = {
                    criteria: scope.searchCriteria,
                    itemId: scope.itemId,
                    pageNumber: 0,
                    itemsPerPage: 100000,
                    sortBy: '',
                    sortDirection: Model.SortDirection.Ascending,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    entityType: attrs.entityType
                };
            }
            scope.filterRightArray = () => {
                scope.buildRequest();
                if (Model.Guard.isNothing(scope.rightArrayLocationGroup)) {
                    scope.rightArray.forEach(function (d) { d.disabled = false; });
                    scope.rightArray = _.sortBy(scope.rightArray, 'storeName')
                    return
                }
                scope.searchCriteria.locationGroupId = scope.rightArrayLocationGroup.id;
                this.dataService.getListPaged('location/availability', scope.request).then(function (result: any) {
                    var ids = {};
                    _.each(scope.rightArray, function (r: any) { ids[r.id] = true; });
                    var disable = _.filter(result, function (r: any) { return ids[r.id]; }, scope.rightArray);
                    disable.forEach(function (d) { d.disabled = false; });
                    ids = {};
                    _.each(disable, function (d: any) { ids[d.id] = true; });
                    var enable = _.filter(scope.rightArray, function (r: any) { return !ids[r.id]; }, disable);
                    enable.forEach(function (d) { d.disabled = true; });
                    scope.rightArray = []
                    scope.rightArray = _.union(disable, enable);
                    scope.reset();
                });
            }

            scope.selectedStateChanged = () => {
                scope.selectedCity = undefined;
                scope.cityCriteria = scope.selectedState ? { state: scope.selectedState.state } : {};
            }

            scope.search = () => {
                scope.buildRequest();
                this.dataService.getListPaged('location/availability', scope.request).then(function (result: any) {
                    if (!result) return;
                    if (scope.vm.postProcessLocations) {
                        result = scope.vm.postProcessLocations(result);
                    }
                    result.forEach(function (r: any) {
                        // Commented out this code as is caused bug # 75283
                        //let sameLocation = scope.rightArray.filter((item) => { return item.id === r.id })[0];
                        //if (r.isIncludeDiscount === false && !sameLocation) {
                        //    scope.rightArray.push(r);
                        //}
                        r.disabled = false;
                    });
                    //scope.filterRightArray();
                    scope.leftArray = [];
                    var ids = {};
                    if (scope.rightArray.length) {
                        _.each(scope.rightArray, function (r: any) { ids[r.id] = true; });
                        scope.leftArray = _.filter(result, function (r: any) { return !ids[r.id]; }, scope.rightArray);
                    } else {
                        scope.leftArray = result;
                    }
                    scope.noRecordsFound = result.length === 0;
                    scope.locations = result;
                    scope.setMoverMaxHeight();
                });

            }

            scope.search();

            scope.reset = () => {
                scope.selectedState = undefined;
                scope.selectedCity = undefined;
                scope.selectedLocationGroup = undefined;
                scope.searchCriteria.businessType = undefined;
                scope.cityCriteria = {};
                scope.searchCriteria = {
                    city: undefined,
                    state: undefined,
                    storeName: undefined,
                    locationGroupId: undefined,
                    zipCode: undefined
                }
                scope.search();
            }

            var uniqId = (item) => { return item.id };
            scope.moveAllFromRight = () => {
                var allowedItems = _.filter(scope.rightArray, function (r: any) { return r.disabled === false }, scope.rightArray);
                scope.leftArray = _.uniq(scope.leftArray.concat(allowedItems), uniqId)
                scope.leftArray = _.sortBy(scope.leftArray, 'storeName');
                scope.rightArray = _.filter(scope.rightArray, function (r: any) { return r.disabled === true }, scope.rightArray);
            }

            scope.moveAllFromLeft = () => {
                scope.rightArray = _.uniq(scope.rightArray.concat(scope.leftArray), uniqId)
                scope.rightArray = _.sortBy(scope.rightArray, 'storeName');
                scope.leftArray = [];
                if (Model.Guard.isSomething(scope.exclusionLocationGroup))
                    scope.filterRightArray();
            }

            scope.moveToRight = (items) => {
                _.each(items, (item) => {
                    scope.rightArray.push(item);
                    var index = scope.leftArray.indexOf(item);
                    scope.leftArray.splice(index, 1);
                })
                if (items.length > 0 && Model.Guard.isSomething(scope.exclusionLocationGroup))
                    scope.filterRightArray();
                else
                    scope.rightArray = _.sortBy(scope.rightArray, 'storeName')
            }

            scope.moveToLeft = (items) => {
                _.each(items, (item) => {
                    scope.leftArray.push(item);
                    var index = scope.rightArray.indexOf(item);
                    scope.rightArray.splice(index, 1);
                })
                scope.leftArray = _.sortBy(scope.leftArray, 'storeName');
            }

            scope.mobileApply = () => {
                scope.rightArray = scope.locations.filter((item) => scope.vm.selectedLocationIds.indexOf(item.id) !== -1);
                scope.vm.apply(scope.rightArray);
            }

            scope.setMoverMaxHeight = () => {
                setTimeout(() => {
                    var el = element.find('.smart-mover__collection-row')[0];
                    if (!el) return;
                    el.style.maxHeight = 'unset';
                    el.style.transition = 'height 0.2s ease-in-out';
                    el.style.height = (window.innerHeight - el.getBoundingClientRect().top - 80) + 'px';
                }, 500);
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService, identityService: Meevo.Components.Common.IIdentityService) => {
                return new MeevoMultiLocationPicker(dataService, identityService);
            };
            directive.$inject = ["meevo.components.common.DataService", "meevo.components.common.IdentityService"]
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMultiLocationPicker", MeevoMultiLocationPicker.factory());
}
